<template>
  <transition
    enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
    enter-class="translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
    leave-from-class="translate-x-0"
    leave-to-class="translate-x-full"
  >
    <div
      v-if="isOpen"
      class="
        z-20
        fixed
        top-16
        bottom-0
        right-0
        w-full
        max-w-md
        bg-white
        shadow-xl
      "
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppSlideOverPanel',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
